import BaseElement from './BaseElement'
import { WishlistButton } from '../components/WishlistButton'

export default class WishlistButtonElement extends BaseElement {
  static get observedAttributes() {
    return ['product', 'variant-selected-id', 'template-suffix', 'product-bi-line', 'variant-selected', 'is-show-only-icon', 'product-personalised-price', 'use-product-slideout']
  }

  renderElement() {
    const product = this.getAttribute('product') && JSON.parse(this.getAttribute('product') as string)
    const variantSelectedAttr = this.getAttribute('variant-selected')
    const variantSelected = (variantSelectedAttr && JSON.parse(variantSelectedAttr as string)) || product?.selected_or_first_available_variant || product?.variants?.[0] || null
    const productBiLine = this.getAttribute('product-bi-line') as string
    const variantSelectedIdAttr = this.getAttribute('variant-selected-id') as string
    const parsedVariantSelectedId = parseInt(variantSelectedIdAttr)
    const variantSelectedId = Number.isFinite(parsedVariantSelectedId) ? parsedVariantSelectedId : variantSelected?.id || 0
    const disableWishlist = this.getAttribute('disabled') as string
    const errorMessage = this.getAttribute('error-message') as string
    const templateSuffix = this.getAttribute('template-suffix') as string
    const isShowOnlyIcon = (this.getAttribute('is-show-only-icon') && (JSON.parse(this.getAttribute('is-show-only-icon') as string) as boolean)) || false
    const productPersonalisedPrice = this.getAttribute('product-personalised-price') && JSON.parse(this.getAttribute('product-personalised-price') as string)
    const useProductSlideout = (this.getAttribute('use-product-slideout') && (JSON.parse(this.getAttribute('use-product-slideout') as string) as boolean)) || false

    if (!this.rootElement) {
      return
    }

    this.rootElement.render(
      <WishlistButton
        product={product}
        productBiLine={productBiLine}
        variantSelected={variantSelected}
        variantSelectedId={variantSelectedId}
        templateSuffix={templateSuffix}
        disableWishlist={disableWishlist}
        errorMessage={errorMessage}
        isShowOnlyIcon={isShowOnlyIcon}
        productPersonalisedPrice={productPersonalisedPrice}
        useProductSlideout={useProductSlideout}
      />
    )
  }
}
